import React, { useState, useEffect } from 'react';

// Kalender-Komponente fuer Terminauswahl (Design wie Kursplan)
function BirthdayCalendar({ availability, selectedDate, onDateSelect, selectedSlot, onSlotSelect, formatDate }) {
  const [currentMonth, setCurrentMonth] = useState(new Date());

  // Erstelle ein Set mit verfuegbaren Daten fuer schnellen Lookup
  const availableDatesMap = {};
  availability.forEach(item => {
    availableDatesMap[item.date] = item;
  });

  const monthNames = [
    'Januar', 'Februar', 'Maerz', 'April', 'Mai', 'Juni',
    'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
  ];

  const dayNames = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];

  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();

    let startDayOfWeek = firstDay.getDay() - 1;
    if (startDayOfWeek < 0) startDayOfWeek = 6;

    const days = [];

    for (let i = 0; i < startDayOfWeek; i++) {
      days.push(null);
    }

    for (let day = 1; day <= daysInMonth; day++) {
      const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
      const dateData = availableDatesMap[dateStr];
      days.push({
        day,
        date: dateStr,
        available: dateData && dateData.slots && dateData.slots.length > 0,
        data: dateData || null
      });
    }

    return days;
  };

  // Teile Tage in Wochen auf
  const getWeeks = (days) => {
    const weeks = [];
    let currentWeek = [];

    days.forEach((day, idx) => {
      currentWeek.push(day);
      if (currentWeek.length === 7) {
        weeks.push(currentWeek);
        currentWeek = [];
      }
    });

    // Letzte Woche auffuellen
    while (currentWeek.length > 0 && currentWeek.length < 7) {
      currentWeek.push(null);
    }
    if (currentWeek.length > 0) {
      weeks.push(currentWeek);
    }

    return weeks;
  };

  const goToPrevMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1));
  };

  const goToNextMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1));
  };

  const days = getDaysInMonth(currentMonth);
  const weeks = getWeeks(days);
  const today = new Date();
  const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

  const prevMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1);
  const canGoPrev = prevMonth >= new Date(today.getFullYear(), today.getMonth(), 1);

  return (
    <div>
      {/* Navigation */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <button
          className="btn btn-outline-secondary btn-sm"
          onClick={goToPrevMonth}
          disabled={!canGoPrev}
        >
          &larr; Vorheriger
        </button>
        <h5 className="mb-0">{monthNames[currentMonth.getMonth()]} {currentMonth.getFullYear()}</h5>
        <button className="btn btn-outline-secondary btn-sm" onClick={goToNextMonth}>
          Naechster &rarr;
        </button>
      </div>

      {/* Kalender Tabelle (wie Kursplan) */}
      <div className="table-responsive">
        <table className="table table-bordered">
          <thead>
            <tr>
              {dayNames.map((name, idx) => (
                <th
                  key={idx}
                  className="text-center"
                  style={{ width: '14.28%' }}
                >
                  <div className="fw-bold">{name}</div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {weeks.map((week, weekIdx) => (
              <tr key={weekIdx}>
                {week.map((dayObj, dayIdx) => (
                  <td
                    key={dayIdx}
                    className={`text-center align-middle p-2 ${
                      dayObj?.date === todayStr ? 'bg-warning bg-opacity-10' : ''
                    }`}
                    style={{ height: '80px', verticalAlign: 'middle' }}
                  >
                    {dayObj && (
                      <div
                        onClick={() => dayObj.available && onDateSelect(dayObj.data)}
                        style={{ cursor: dayObj.available ? 'pointer' : 'default' }}
                      >
                        <div className={`small ${dayObj.date === todayStr ? 'fw-bold' : 'text-muted'}`}>
                          {dayObj.day}
                        </div>
                        {/* Termine anzeigen - frei und/oder gebucht */}
                        {dayObj.data && (dayObj.available || dayObj.data.booked_slots?.length > 0) && (
                          <div
                            className="card mt-1 mx-auto"
                            style={{
                              cursor: dayObj.available ? 'pointer' : 'default',
                              borderLeft: dayObj.available ? '4px solid #9c27b0' : '4px solid #ff9800',
                              backgroundColor: selectedDate?.date === dayObj.date ? 'rgba(156, 39, 176, 0.2)' : 'white',
                              maxWidth: '90px'
                            }}
                          >
                            <div className="card-body p-1">
                              <div className="small fw-bold" style={{ color: dayObj.available ? '#9c27b0' : '#ff9800', fontSize: '0.7rem' }}>
                                {dayObj.data.day_name.substring(0, 2)}
                              </div>
                              <div style={{ fontSize: '0.65rem' }}>
                                {dayObj.available && (
                                  <span className="badge bg-success me-1" style={{ fontSize: '0.6rem' }}>
                                    {dayObj.data.slots.length} frei
                                  </span>
                                )}
                                {dayObj.data.booked_slots?.length > 0 && (
                                  <span className="badge" style={{ fontSize: '0.6rem', backgroundColor: '#ff9800' }}>
                                    {dayObj.data.booked_slots.length} gebucht
                                  </span>
                                )}
                                {!dayObj.available && dayObj.data.booked_slots?.length > 0 && (
                                  <div className="mt-1">
                                    <small style={{ color: '#ff9800', fontWeight: 'bold' }}>ausgebucht</small>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Legende */}
      <div className="d-flex flex-wrap gap-4 mt-2 mb-4 small text-muted">
        <div>
          <span className="badge bg-success me-1" style={{ fontSize: '0.7rem' }}>frei</span>
          Verfuegbare Termine
        </div>
        <div>
          <span className="badge me-1" style={{ fontSize: '0.7rem', backgroundColor: '#ff9800' }}>gebucht</span>
          Bereits vergeben
        </div>
        <div>
          <span style={{ display: 'inline-block', width: '16px', height: '16px', borderLeft: '4px solid #ff9800', backgroundColor: 'white', verticalAlign: 'middle', marginRight: '4px' }}></span>
          Ausgebucht (nicht mehr buchbar)
        </div>
      </div>

      {/* Slot Auswahl wenn Datum gewaehlt */}
      {selectedDate && (
        <div className="card" style={{ borderLeft: '4px solid #9c27b0' }}>
          <div className="card-header" style={{ backgroundColor: 'rgba(156, 39, 176, 0.1)' }}>
            <strong style={{ color: '#9c27b0' }}>{formatDate(selectedDate.date)}</strong>
          </div>
          <div className="card-body">
            <p className="mb-3">Waehle eine Startzeit:</p>
            <div className="d-flex flex-wrap gap-2">
              {selectedDate.slots.map((slot, idx) => (
                <button
                  key={idx}
                  className={`btn btn-lg ${selectedSlot?.start_time === slot.start_time ? '' : 'btn-outline-secondary'}`}
                  style={selectedSlot?.start_time === slot.start_time ? { backgroundColor: '#9c27b0', color: 'white', borderColor: '#9c27b0' } : {}}
                  onClick={() => onSlotSelect(slot)}
                >
                  {slot.start_time} - {slot.end_time} Uhr
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function Geburtstage() {
  const [packages, setPackages] = useState([]);
  const [themes, setThemes] = useState([]);
  const [availability, setAvailability] = useState([]);
  const [loading, setLoading] = useState(true);
  const [step, setStep] = useState(1);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const [selectedPackage, setSelectedPackage] = useState(null);
  const [selectedTheme, setSelectedTheme] = useState(null);
  const [customTheme, setCustomTheme] = useState('');
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);

  const [formData, setFormData] = useState({
    parent_name: '',
    parent_email: '',
    parent_phone: '',
    child_name: '',
    child_age: '',
    num_children: 8,
    message: ''
  });

  useEffect(() => {
    Promise.all([
      fetch('/api/v2/geburtstag/packages').then(r => r.json()),
      fetch('/api/v2/geburtstag/themes').then(r => r.json()),
      fetch('/api/v2/geburtstag/availability').then(r => r.json())
    ]).then(([pkgData, themeData, availData]) => {
      setPackages(pkgData.data || []);
      setThemes(themeData.data || []);
      setAvailability(availData.data || []);
      setLoading(false);
    }).catch(err => {
      console.error('Fehler:', err);
      setLoading(false);
    });
  }, []);

  const handleDateSelect = (dateObj) => {
    setSelectedDate(dateObj);
    // If only one slot, auto-select it
    if (dateObj.slots.length === 1) {
      setSelectedSlot(dateObj.slots[0]);
      setStep(2); // Gehe zu Paket-Auswahl
    } else {
      setSelectedSlot(null);
    }
  };

  const handleSlotSelect = (slot) => {
    setSelectedSlot(slot);
    setStep(2); // Gehe zu Paket-Auswahl
  };

  const handlePackageSelect = (pkg) => {
    setSelectedPackage(pkg);
    setStep(3); // Gehe zu Thema-Auswahl
  };

  const handleThemeSelect = (theme) => {
    setSelectedTheme(theme);
    setCustomTheme('');
    setStep(4); // Gehe zu Details
  };

  const handleCustomTheme = () => {
    if (!customTheme.trim()) {
      alert('Bitte ein individuelles Thema eingeben');
      return;
    }
    setSelectedTheme(null);
    setStep(4); // Gehe zu Details
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);

    try {
      const response = await fetch('/api/v2/geburtstag/book', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          date: selectedDate.date,
          start_time: selectedSlot.start_time,
          package_id: selectedPackage.id,
          theme_id: selectedTheme?.id || null,
          custom_theme: customTheme || null,
          parent_name: formData.parent_name,
          parent_email: formData.parent_email,
          parent_phone: formData.parent_phone,
          child_name: formData.child_name,
          child_age: formData.child_age ? parseInt(formData.child_age) : null,
          num_children: parseInt(formData.num_children),
          message: formData.message
        })
      });

      const data = await response.json();

      if (data.message === 'success') {
        setSuccess(true);
        setStep(5);
      } else {
        setError(data.error || 'Ein Fehler ist aufgetreten.');
      }
    } catch (err) {
      setError('Verbindungsfehler. Bitte versuche es erneut.');
    } finally {
      setSubmitting(false);
    }
  };

  const resetBooking = () => {
    setStep(1);
    setSelectedPackage(null);
    setSelectedTheme(null);
    setCustomTheme('');
    setSelectedDate(null);
    setSelectedSlot(null);
    setFormData({
      parent_name: '', parent_email: '', parent_phone: '',
      child_name: '', child_age: '', num_children: 8, message: ''
    });
    setSuccess(false);
    setError('');
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('de-DE', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' });
  };

  const formatPrice = (price) => parseFloat(price).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });

  // Calculate total price based on package and number of children
  const calculateTotalPrice = (pkg, numChildren) => {
    if (!pkg) return 0;
    const basePrice = parseFloat(pkg.price) || 0;
    const pricePerChild = parseFloat(pkg.price_per_child) || 0;
    return basePrice + (pricePerChild * numChildren);
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Laden...</span>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="text-center py-4">
        <h1 className="display-5 mb-2">Kindergeburtstage</h1>
        <p className="lead text-muted">
          Erlebe einen unvergesslichen Geburtstag bei Futurhinos!
        </p>
        <p className="text-muted">
          Verfuegbar: Freitag 17-20 Uhr | Samstag 14-20 Uhr (3 Stunden)
        </p>
      </div>

      {/* Progress Steps */}
      <div className="row justify-content-center mb-4">
        <div className="col-lg-10">
          <div className="d-flex justify-content-between align-items-center">
            {['Termin', 'Paket', 'Thema', 'Details', 'Fertig'].map((label, idx) => (
              <div key={idx} className="text-center flex-fill">
                <div
                  className={`rounded-circle mx-auto mb-2 d-flex align-items-center justify-content-center ${
                    step > idx + 1 ? 'bg-success' : step === idx + 1 ? 'bg-primary' : 'bg-secondary'
                  }`}
                  style={{ width: '36px', height: '36px', color: 'white', fontSize: '14px' }}
                >
                  {step > idx + 1 ? '✓' : idx + 1}
                </div>
                <small className={step === idx + 1 ? 'fw-bold' : 'text-muted'}>{label}</small>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Step 1: Select Date & Time (Kalender zuerst) */}
      {step === 1 && (
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <h4 className="mb-4 text-center">Waehle einen Termin</h4>

            {availability.length === 0 ? (
              <div className="alert alert-warning">
                <h5>Keine Termine verfuegbar</h5>
                <p>Aktuell sind keine freien Termine vorhanden. Bitte kontaktiere uns.</p>
                <a href="mailto:info@futurhinos-kids.de" className="btn btn-primary">E-Mail senden</a>
              </div>
            ) : (
              <BirthdayCalendar
                availability={availability}
                selectedDate={selectedDate}
                onDateSelect={handleDateSelect}
                selectedSlot={selectedSlot}
                onSlotSelect={handleSlotSelect}
                formatDate={formatDate}
              />
            )}
          </div>
        </div>
      )}

      {/* Step 2: Select Package */}
      {step === 2 && (
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <button className="btn btn-outline-secondary" onClick={() => { setSelectedSlot(null); setStep(1); }}>
                &larr; Zurueck
              </button>
              <h4 className="mb-0">Waehle dein Paket</h4>
              <div style={{ width: '80px' }}></div>
            </div>

            <div className="card mb-4 bg-light">
              <div className="card-body">
                <strong>Termin:</strong> {formatDate(selectedDate.date)}, {selectedSlot.start_time} - {selectedSlot.end_time} Uhr
              </div>
            </div>

            <div className="row justify-content-center">
              {packages.map(pkg => (
                <div key={pkg.id} className="col-md-5 mb-4">
                  <div
                    className="card h-100"
                    style={{ cursor: 'pointer' }}
                    onClick={() => handlePackageSelect(pkg)}
                  >
                    <div className="card-body text-center">
                      <h4 className="card-title">{pkg.name}</h4>
                      {parseFloat(pkg.price_per_child) > 0 ? (
                        <>
                          <p className="text-muted mb-1">Basis-Paket +</p>
                          <h2 className="text-success mb-3">{formatPrice(pkg.price_per_child)} pro Kind</h2>
                        </>
                      ) : (
                        <h2 className="text-success mb-3">{formatPrice(pkg.price)}</h2>
                      )}
                      <p className="card-text">{pkg.description}</p>
                      {pkg.includes && (
                        <div className="text-start mt-3">
                          <strong>Inklusive:</strong>
                          <ul className="small mt-2">
                            {pkg.includes.split(',').map((item, idx) => (
                              <li key={idx}>{item.trim()}</li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                    <div className="card-footer bg-transparent border-0 pb-4">
                      <button className="btn w-100 btn-primary">
                        Auswaehlen
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Step 3: Select Theme */}
      {step === 3 && (
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <button className="btn btn-outline-secondary" onClick={() => setStep(2)}>
                &larr; Zurueck
              </button>
              <h4 className="mb-0">Waehle ein Thema</h4>
              <div style={{ width: '80px' }}></div>
            </div>

            <div className="card mb-4 bg-light">
              <div className="card-body">
                <strong>Termin:</strong> {formatDate(selectedDate.date)}, {selectedSlot.start_time} - {selectedSlot.end_time} Uhr |
                <strong> Paket:</strong> {selectedPackage.name}
                {parseFloat(selectedPackage.price_per_child) > 0
                  ? ` (Basis-Paket + ${formatPrice(selectedPackage.price_per_child)}/Kind)`
                  : ` (${formatPrice(selectedPackage.price)})`}
              </div>
            </div>

            <div className="row">
              {themes.map(theme => (
                <div key={theme.id} className="col-md-4 mb-4">
                  <div className="card h-100" style={{ cursor: 'pointer' }} onClick={() => handleThemeSelect(theme)}>
                    {theme.image && (
                      <img src={theme.image} className="card-img-top" alt={theme.name} style={{ height: '150px', objectFit: 'cover' }} />
                    )}
                    <div className="card-body">
                      <h5 className="card-title">{theme.name}</h5>
                      <p className="card-text small text-muted">{theme.description}</p>
                      <span className="badge bg-info">{theme.min_age}-{theme.max_age} Jahre</span>
                    </div>
                    <div className="card-footer bg-transparent border-0">
                      <button className="btn btn-primary w-100">Auswaehlen</button>
                    </div>
                  </div>
                </div>
              ))}

              {/* Custom Theme */}
              <div className="col-md-4 mb-4">
                <div className="card h-100 border-dashed">
                  <div className="card-body d-flex flex-column justify-content-center">
                    <h5 className="card-title text-center">Individuelles Thema</h5>
                    <p className="card-text small text-muted text-center">
                      Du hast eine eigene Idee? Sag uns, was du dir vorstellst!
                    </p>
                    <input
                      type="text"
                      className="form-control mb-3"
                      placeholder="z.B. Pokemon, Star Wars..."
                      value={customTheme}
                      onChange={e => setCustomTheme(e.target.value)}
                    />
                    <button className="btn btn-outline-primary w-100" onClick={handleCustomTheme}>
                      Mit diesem Thema weiter
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Step 4: Booking Form */}
      {step === 4 && (
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <button className="btn btn-outline-secondary" onClick={() => setStep(3)}>
                &larr; Zurueck
              </button>
              <h4 className="mb-0">Buchungsdetails</h4>
              <div style={{ width: '80px' }}></div>
            </div>

            <div className="card mb-4 bg-light">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <p className="mb-1"><strong>Paket:</strong> {selectedPackage.name}</p>
                    <p className="mb-1"><strong>Thema:</strong> {selectedTheme?.name || customTheme}</p>
                  </div>
                  <div className="col-md-6">
                    <p className="mb-1"><strong>Datum:</strong> {formatDate(selectedDate.date)}</p>
                    <p className="mb-1"><strong>Uhrzeit:</strong> {selectedSlot.start_time} - {selectedSlot.end_time} Uhr</p>
                  </div>
                </div>
              </div>
            </div>

            {error && <div className="alert alert-danger">{error}</div>}

            <form onSubmit={handleSubmit}>
              <div className="card mb-4">
                <div className="card-header"><strong>Geburtstagskind</strong></div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-5 mb-3">
                      <label className="form-label">Name des Kindes *</label>
                      <input type="text" className="form-control" value={formData.child_name}
                        onChange={e => setFormData({ ...formData, child_name: e.target.value })} required />
                    </div>
                    <div className="col-md-3 mb-3">
                      <label className="form-label">Wird ... Jahre</label>
                      <input type="number" className="form-control" value={formData.child_age}
                        onChange={e => setFormData({ ...formData, child_age: e.target.value })} min="4" max="16" />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Anzahl Kinder (inkl. Geburtstagskind) *</label>
                      <input type="number" className="form-control" value={formData.num_children}
                        onChange={e => setFormData({ ...formData, num_children: e.target.value })} min="4" max="15" required />
                    </div>
                  </div>
                </div>
              </div>

              <div className="card mb-4">
                <div className="card-header"><strong>Kontaktdaten (Elternteil)</strong></div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Ihr Name *</label>
                      <input type="text" className="form-control" value={formData.parent_name}
                        onChange={e => setFormData({ ...formData, parent_name: e.target.value })} required />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">E-Mail *</label>
                      <input type="email" className="form-control" value={formData.parent_email}
                        onChange={e => setFormData({ ...formData, parent_email: e.target.value })} required />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Telefon</label>
                      <input type="tel" className="form-control" value={formData.parent_phone}
                        onChange={e => setFormData({ ...formData, parent_phone: e.target.value })} />
                    </div>
                  </div>
                </div>
              </div>

              <div className="card mb-4">
                <div className="card-body">
                  <label className="form-label">Nachricht / Besondere Wuensche</label>
                  <textarea className="form-control" rows="3" value={formData.message}
                    onChange={e => setFormData({ ...formData, message: e.target.value })}
                    placeholder="Allergien, besondere Wuensche, Fragen..." />
                </div>
              </div>

              <div className="card mb-4 bg-success text-white">
                <div className="card-body">
                  <div className="row align-items-center">
                    <div className="col-md-8">
                      <h5 className="mb-1">Gesamtpreis</h5>
                      {parseFloat(selectedPackage.price_per_child) > 0 ? (
                        <small>
                          Basis-Paket ({formatPrice(selectedPackage.price)}) + {formData.num_children} Kinder × {formatPrice(selectedPackage.price_per_child)}
                        </small>
                      ) : (
                        <small>{selectedPackage.name}</small>
                      )}
                    </div>
                    <div className="col-md-4 text-end">
                      <h3 className="mb-0">{formatPrice(calculateTotalPrice(selectedPackage, parseInt(formData.num_children) || 0))}</h3>
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-grid">
                <button type="submit" className="btn btn-success btn-lg" disabled={submitting}>
                  {submitting ? (
                    <><span className="spinner-border spinner-border-sm me-2"></span>Wird gebucht...</>
                  ) : (
                    'Jetzt verbindlich buchen'
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Step 5: Success */}
      {step === 5 && success && (
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="card border-success">
              <div className="card-body text-center py-5">
                <div className="mb-4" style={{ fontSize: '4rem' }}>🎉</div>
                <h3 className="text-success mb-3">Buchung erfolgreich!</h3>
                <p className="lead">Wir haben dir eine Bestaetigung per E-Mail gesendet.</p>

                <div className="card bg-light mt-4 mb-4">
                  <div className="card-body text-start">
                    <h5 className="mb-3">Buchungsdetails</h5>
                    <div className="row">
                      <div className="col-md-6">
                        <p><strong>Geburtstagskind:</strong> {formData.child_name}</p>
                        <p><strong>Thema:</strong> {selectedTheme?.name || customTheme}</p>
                        <p><strong>Paket:</strong> {selectedPackage.name}</p>
                      </div>
                      <div className="col-md-6">
                        <p><strong>Datum:</strong> {formatDate(selectedDate.date)}</p>
                        <p><strong>Uhrzeit:</strong> {selectedSlot.start_time} - {selectedSlot.end_time} Uhr</p>
                        <p><strong>Anzahl Kinder:</strong> {formData.num_children}</p>
                        <p><strong>Preis:</strong> {formatPrice(calculateTotalPrice(selectedPackage, parseInt(formData.num_children) || 0))}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <p className="text-muted">Bei Fragen kontaktiere uns gerne.</p>
                <button className="btn btn-primary mt-3" onClick={resetBooking}>Weitere Buchung</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Geburtstage;
